// extracted by mini-css-extract-plugin
module.exports = {"container":"Tab__container--3XeSm","active":"Tab__active--3a-Eq"};